import { portfolioGeneralRoutes } from './general';

export const portfolioRoutes = [
  {
    path: 'portfolio',
    children: [...portfolioGeneralRoutes],
  },
];
